export const STRIPE_FIXED_FEE_EUR = 0.25;
export const STRIPE_COMMISSION_RATE = 0.015;
